import { createSlice } from "@reduxjs/toolkit";
import { initialMapState } from "../config/config.map";
export const mapSlice = createSlice({
  name: "map",
  initialState: initialMapState,
  reducers: {
    setZoom(state, action) {
      state.zoom = action.payload.zoom;
    },
    setLatLon(state, action) {
      const { lat, lon } = action.payload;
      state.lat = lat;
      state.lon = lon;
    },
    setBasemap(state, action) {
      state.basemap = action.payload;
    },
  },
});
